/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import React, { memo } from "react";
import { Button } from "./ui/button";
import { Minus, Plus } from "lucide-react";
import { cn } from "@/lib/utils";

const Counter = ({
  countNumber = 1,
  setCountNumber,
  small,
  min = 0,
}: {
  countNumber?: number;
  setCountNumber: (number: number) => void;
  small?: boolean;
  min?: number;
}) => {
  const handleIncrement = () => {
    setCountNumber(Number(countNumber + 1));
  };
  const handleDecrement = () => {
    setCountNumber(Number(countNumber - 1));
  };

  return (
    <div className="flex text-xs text-gray-dark items-center gap-1">
      <Button
        variant={"ghost"}
        size={"icon"}
        disabled={countNumber >= 30}
        onClick={handleIncrement}
        className={cn({
          "size-6 bg-green-background": small,
        })}
        aria-label="increment button"
      >
        <Plus />
      </Button>
      <span
        className={cn("text-base", {
          "text-xs": small,
        })}
      >
        {countNumber}
      </span>
      <Button
        variant={"ghost"}
        size={"icon"}
        disabled={countNumber <= min}
        onClick={handleDecrement}
        className={cn({
          "size-6 bg-green-background": small,
        })}
        aria-label="decrement button"
      >
        <Minus />
      </Button>
    </div>
  );
};

export default memo(Counter);
